import { render, staticRenderFns } from "./DocumentRow.vue?vue&type=template&id=c2024070&scoped=true"
import script from "./DocumentRow.vue?vue&type=script&lang=js"
export * from "./DocumentRow.vue?vue&type=script&lang=js"
import style0 from "./DocumentRow.vue?vue&type=style&index=0&id=c2024070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2024070",
  null
  
)

export default component.exports